export const CREATE_NEW_USER = "Create New User";
export const NO_USERS_DATA = "Sorry, we couldn't find any users with this search criteria.";